import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=01c7fcb5&scoped=true"
import script from "./FaIcon.vue?vue&type=script&lang=js"
export * from "./FaIcon.vue?vue&type=script&lang=js"
import style0 from "./FaIcon.vue?vue&type=style&index=0&id=01c7fcb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7fcb5",
  null
  
)

export default component.exports